export const ApiUrls = {
    dashboard:'admin/dashboard',
}
